import "./Css/Description.css";
const Description = ({ catDescription }) => {
  return (
    <>
      <div className="description-box">
        <p
          className="description-text"
          dangerouslySetInnerHTML={{ __html: catDescription }}
        />
      </div>
    </>
  );
};
export default Description;
